import { getVendorKey } from '../../../../../Containers/Config';
import {
  FETCH_VENDORS_BY_REGION,
  FETCH_VENDORS_BY_REGION_SUCCESS,
  FETCH_VENDORS_BY_REGION_ERROR,
  FETCH_VENDORS_BY_REGION_EMPTY,
} from '../../actions';

const initialState = {
  vendorsByLocation: {},
};

const FetchVendorByRegion = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VENDORS_BY_REGION: {
      const { regionId } = action.payload;
      const key = getVendorKey(regionId);

      return {
        ...state,
        vendorsByLocation: {
          ...state.vendorsByLocation,
          [key]: {
            loading: true,
            success: false,
            error: false,
            data: null,
          },
        },
      };
    }

    case FETCH_VENDORS_BY_REGION_SUCCESS: {
      const { key, data } = action.payload;

      return {
        ...state,
        vendorsByLocation: {
          ...state.vendorsByLocation,
          [key]: {
            loading: false,
            success: true,
            error: false,
            data,
          },
        },
      };
    }

    case FETCH_VENDORS_BY_REGION_ERROR: {
      const { key, error } = action.payload;

      return {
        ...state,
        vendorsByLocation: {
          ...state.vendorsByLocation,
          [key]: {
            loading: false,
            success: false,
            error: true,
            data: null,
            message: error,
          },
        },
      };
    }

    case FETCH_VENDORS_BY_REGION_EMPTY:
      return initialState;

    default:
      return state;
  }
};

export default FetchVendorByRegion;
